<template>
	<div id="emergencyCTA">
		<h3>Emergency or rush order?</h3>
		<p>Emergency or rush orders need to be placed directly with our order department</p>
        <a href="https://www.jcsteele.com/contact-us/" class="btn btn-primary" target="_blank">Contact us today</a>
		<a :href="'tel:' + companyPhone" class="CTAPhone">{{companyPhone}}</a>
	</div>
</template>

<script>
import Vue from "vue";
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
	export default {
		name: "EmergencyCta",
		mounted() {
			this.settingsDetails();

			Vue.filter("companyPhone", function(companyPhone) {
			return companyPhone
				.replace(/[^0-9]/g, "")
				.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
			});
		},
		data() {
			return {
				companyPhone: "",
			}
		},
		methods: {
			settingsDetails() {
			apiService
				.getCompanySettings()
				.then((request) => {
				this.settingsSuccessful(request);
				})
				.catch((err) => this.settingsFailed(err));
			},
			settingsSuccessful(request) {
				(this.companyPhone = request.companyPhone);
			},
			settingsFailed(err) {
				this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
					title: err.error.response.data.title,
					autoHideDelay: 10000,
					appendToast: false,
					variant: "danger",
					solid: true,
				});
			},
		}
	};
</script>
